import { render, staticRenderFns } from "./SuccessNew.vue?vue&type=template&id=89c5d60a&"
import script from "./SuccessNew.vue?vue&type=script&lang=js&"
export * from "./SuccessNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports